/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {StartTimecardBreakRequest} from '@cash-web/protos/squareup/timecards/timecards_service.pb'
import {StartTimecardBreakResponse} from '@cash-web/protos/squareup/timecards/timecards_service.pb'


export const startTimecardBreak = (request: StartTimecardBreakRequest, options?: CashRequestOptions) => post<StartTimecardBreakRequest, StartTimecardBreakResponse>("/proxy/services/squareup.timecards.PublicTimecardsService/StartTimecardBreak", request, {...options, rejectOnError: true })